import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import InputMask from "react-input-mask";

import { withStyles } from "@material-ui/core/styles";
import TablePagination from "@material-ui/core/TablePagination";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import AlertIcon from "@material-ui/icons/Error";
import Checkbox from "@material-ui/core/Checkbox";
import { InputAdornment, Box, Divider } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";

import MainLayout from "../MainLayout";
import {
  formatDate,
  calcDateDiff,
  getStatusLabel,
  ordersPageTitle,
} from "../utils";
import { baseUrl, currentRole, Roles, orderStatus } from "../config";

import useStyles from "./styles";

const StyledTableRow = withStyles(() => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "#F4F6F8",
    },
  },
}))(TableRow);

const StyledTableHead = withStyles(() => ({
  root: {
    backgroundColor: "#FAFAFA",
  },
}))(TableHead);

const sortOptions = [
  {
    value: "createdAt|desc",
    label: "Sipariş Tarihi (Yeniden eskiye)",
  },
  {
    value: "createdAt|asc",
    label: "Sipariş Tarihi (Eskiden yeniye)",
  },
  {
    value: "name|asc",
    label: "Müşteri Adı (A-Z)",
  },
  {
    value: "name|desc",
    label: "Müşteri Adı (Z-A)",
  },
];

function applyFilters(orders, query, filters = {}) {
  return orders.filter((order) => {
    let matches = true;

    if (query) {
      const properties = ["name", "lastName"];
      let containsQuery = false;

      properties.forEach((property) => {
        if (order[property].toLowerCase().includes(query.toLowerCase())) {
          containsQuery = true;
        }
      });

      if (!containsQuery) {
        matches = false;
      }
    }

    Object.keys(filters).forEach((key) => {
      const value = filters[key];

      if (value && order[key] !== value) {
        matches = false;
      }
    });

    return matches;
  });
}

function applyPagination(orders, page, limit) {
  return orders.slice(page * limit, page * limit + limit);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }

  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySort(orders, sort) {
  const [orderBy, order] = sort.split("|");
  const comparator = getComparator(order, orderBy);
  const stabilizedThis = orders.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    // eslint-disable-next-line no-shadow
    const order = comparator(a[0], b[0]);

    if (order !== 0) return order;

    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
}

export default function Orders() {
  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("90");
  const [orders, setOrders] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isSearched, setSearched] = useState(false);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [query, setQuery] = useState("");
  const [sort, setSort] = useState(sortOptions[0].value);

  const handleChangePhoneNumber = (event) => {
    const phoneNumber = event.target.value.trim().replace(/\s/g, "");

    setPhoneNumber(phoneNumber);
  };

  const handleQueryChange = (event) => {
    event.persist();
    setQuery(event.target.value);
  };

  const handleSortChange = (event) => {
    event.persist();
    setSort(event.target.value);
  };

  const handleSelectAllOrders = (event) => {
    setSelectedOrders(
      event.target.checked ? orders.map((order) => order._id) : []
    );
  };

  const handleSelectOneOrder = (event, orderId) => {
    if (!selectedOrders.includes(orderId)) {
      setSelectedOrders((prevSelected) => [...prevSelected, orderId]);
    } else {
      setSelectedOrders((prevSelected) =>
        prevSelected.filter((id) => id !== orderId)
      );
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  async function getOrdersWithPhoneNumber() {
    setLoading(true);
    setSearched(true);

    let _baseUrl = `${baseUrl(currentRole)}/orders`;
    if (currentRole === Roles.GETIR_MH) {
      _baseUrl += `/?phoneNumber=${phoneNumber}`;
    }

    const res = await fetch(_baseUrl, {
      headers: {
        Authorization: localStorage.getItem("authToken"),
      },
    });

    res
      .json()
      .then((res) => setOrders(res))
      .then(() => setLoading(false))
      .catch((err) => console.log(err));
  }

  async function getOrders() {
    setLoading(true);
    setSearched(true);

    let _baseUrl = `${baseUrl(currentRole)}/orders`;

    const res = await fetch(_baseUrl, {
      headers: {
        Authorization: localStorage.getItem("authToken"),
      },
    });

    res
      .json()
      .then((res) => setOrders(res.orders ? res.orders : res))
      .then(() => setLoading(false))
      .catch((err) => console.log(err));
  }

  async function prepareBulkOrders() {
    setLoading(true);

    Promise.all(
      selectedOrders.map((orderId) =>
        fetch(`${baseUrl(Roles.PICKER)}/orders/${orderId}/prepare`, {
          headers: {
            Authorization: localStorage.getItem("authToken"),
          },
          method: "POST",
        })
      )
    )
      .then(() => window.location.reload())
      .catch((err) => console.log(err));
  }

  async function receiveBulkOrders() {
    setLoading(true);

    Promise.all(
      selectedOrders.map((orderId) =>
        fetch(`${baseUrl(Roles.COURIER)}/orders/${orderId}/receive`, {
          headers: {
            Authorization: localStorage.getItem("authToken"),
          },
          method: "POST",
          body: JSON.stringify({
            location: {
              coordinates: [],
              type: "POINT",
            },
          }),
        })
      )
    )
      .then(() => window.location.reload())
      .catch((err) => console.log(err));
  }

  async function deliverBulkOrders() {
    setLoading(true);

    Promise.all(
      selectedOrders.map((orderId) =>
        fetch(`${baseUrl(Roles.COURIER)}/orders/${orderId}/deliver`, {
          headers: {
            Authorization: localStorage.getItem("authToken"),
          },
          method: "POST",
          body: JSON.stringify({
            location: {
              coordinates: [],
              type: "POINT",
            },
          }),
        })
      )
    )
      .then(() => window.location.reload())
      .catch((err) => console.log(err));
  }

  const hasResult = !isLoading && orders.length > 0;

  useEffect(() => {
    getOrders();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    getOrdersWithPhoneNumber();
  };

  const filteredOrders = applyFilters(orders, query);
  const sortedOrders = applySort(filteredOrders, sort);
  const paginatedOrders = applyPagination(sortedOrders, page, limit);
  const selectedAllOrders = selectedOrders.length === orders.length;
  const enableBulkOperations = selectedOrders.length > 0;

  return (
    <MainLayout pageTitle={ordersPageTitle(currentRole)}>
      <Backdrop className={classes.backdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Paper className={classes.paper}>
        {currentRole === Roles.GETIR_MH && (
          <form noValidate onSubmit={handleSubmit}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              className={classes.searchSection}
            >
              <Grid item>
                <InputMask
                  mask="90 999 999 99 99"
                  defaultValue="90"
                  maskPlaceholder=" "
                  onChange={handleChangePhoneNumber}
                >
                  {() => (
                    <TextField
                      label="Müşteri Telefon Numarası"
                      id="phoneNumber"
                      name="phoneNumber"
                      autoFocus
                      fullWidth
                      variant="outlined"
                      className={classes.textField}
                    />
                  )}
                </InputMask>
              </Grid>
              <Grid item>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  color="primary"
                  className={classes.button}
                >
                  Arama Yap
                </Button>
              </Grid>
            </Grid>
            <Divider />
          </form>
        )}

        {hasResult > 0 && (
          <>
            <Box p={2} minHeight={56} display="flex" alignItems="center">
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => window.location.reload()}
              >
                <RefreshIcon /> Listeyi Yenile
              </Button>
              <Box flexGrow={1} />
              <TextField
                className={classes.queryField}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={handleQueryChange}
                placeholder="Müşteri ismi ile ara"
                value={query}
                variant="outlined"
              />

              <Box flexGrow={1} />
              <TextField
                label="Sırala"
                name="sort"
                onChange={handleSortChange}
                select
                SelectProps={{ native: true }}
                value={sort}
                variant="outlined"
              >
                {sortOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Box>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              {enableBulkOperations && (
                <div className={classes.bulkOperations}>
                  <div className={classes.bulkActions}>
                    <Checkbox
                      checked={selectedAllOrders}
                      onChange={handleSelectAllOrders}
                    />
                    {currentRole === Roles.PICKER && (
                      <Button
                        variant="outlined"
                        className={classes.bulkAction}
                        onClick={prepareBulkOrders}
                      >
                        Siparişleri Hazırla
                      </Button>
                    )}
                    {currentRole === Roles.COURIER && (
                      <Button
                        variant="outlined"
                        className={classes.bulkAction}
                        onClick={receiveBulkOrders}
                      >
                        Siparişleri Al
                      </Button>
                    )}
                    {currentRole === Roles.COURIER && (
                      <Button
                        variant="outlined"
                        className={classes.bulkAction}
                        onClick={deliverBulkOrders}
                      >
                        Siparişleri Teslim Et
                      </Button>
                    )}
                  </div>
                </div>
              )}
              <Table className={classes.table} aria-label="simple table">
                <StyledTableHead>
                  <StyledTableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedAllOrders}
                        onChange={handleSelectAllOrders}
                      />
                    </TableCell>
                    <TableCell>Müşteri Ad Soyad</TableCell>
                    <TableCell align="right">Sipariş Tarihi</TableCell>
                    <TableCell align="right">Sipariş Durumu</TableCell>
                    <TableCell align="right">Geçen Zaman</TableCell>
                    {currentRole !== Roles.GETIR_MH && (
                      <TableCell align="right">Adres</TableCell>
                    )}
                    {currentRole === Roles.GETIR_MH && (
                      <>
                        <TableCell align="right">Kurye</TableCell>
                        <TableCell align="right">Depo</TableCell>
                      </>
                    )}
                    <TableCell align="right">&nbsp;</TableCell>
                  </StyledTableRow>
                </StyledTableHead>
                <TableBody>
                  {paginatedOrders.map((order) => {
                    const isOrderSelected = selectedOrders.includes(order._id);

                    return (
                      <StyledTableRow
                        key={order._id}
                        hover
                        selected={isOrderSelected}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isOrderSelected}
                            onChange={(event) =>
                              handleSelectOneOrder(event, order._id)
                            }
                            value={isOrderSelected}
                          />
                        </TableCell>

                        <TableCell component="th" scope="row">
                          {`${order.name}  ${order.lastName}`}
                        </TableCell>
                        <TableCell align="right">
                          {formatDate(order.createdAt)}
                        </TableCell>
                        <TableCell align="right">
                          {getStatusLabel(order.status)}
                        </TableCell>
                        <TableCell align="right">
                          {orderStatus.DELIVERED === order.status ||
                          orderStatus.CANCELLED === order.status
                            ? "-"
                            : calcDateDiff(order.createdAt)}
                        </TableCell>
                        {currentRole !== Roles.GETIR_MH && (
                          <TableCell align="right" style={{ fontSize: "10px" }}>
                            {order.addressDirections}
                          </TableCell>
                        )}
                        {currentRole === Roles.GETIR_MH && (
                          <>
                            <TableCell align="right">
                              <Typography>
                                {order.courierName ? order.courierName : "-"}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography>{order.warehouseName}</Typography>
                            </TableCell>
                          </>
                        )}

                        <TableCell align="right">
                          <Button
                            variant="outlined"
                            color="primary"
                            component={Link}
                            target={"_blank"}
                            to={`/orders/${order._id}`}
                          >
                            Detay
                          </Button>
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={filteredOrders.length}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleLimitChange}
                page={page}
                rowsPerPage={limit}
                labelRowsPerPage={"Sayfa başına sipariş"}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </TableContainer>
          </>
        )}
        {!isLoading && isSearched && orders.length === 0 && (
          <Grid container direction="row" justify="center" alignItems="center">
            <AlertIcon />
            <Typography>Sipariş Bulunamadı...</Typography>
          </Grid>
        )}
      </Paper>
    </MainLayout>
  );
}
